// Person name rules (QA batch 12, 2026-10-21; replaces QA batch 8's "letters
// and numbers only"): first / middle / last names of individuals and contact
// people, and Display Name, accept letters of any language (José, Zoë),
// digits, spaces, apostrophes (' and ’), hyphens and periods, so O'Brien,
// Jean-Luc, Mary Ann and J.R. can be entered. Other symbols are refused.
// The same rule is in the backend (`Services/ContactInputRules.cs`).

export const PERSON_NAME_RULE =
  "Use letters, spaces, apostrophes, hyphens or periods.";
export const NAME_PART_RULE = PERSON_NAME_RULE;
export const DISPLAY_NAME_RULE = PERSON_NAME_RULE;

export const NAME_PART_MIN = 2;
export const NAME_PART_MAX = 20;
export const DISPLAY_NAME_MAX = 50;

/** Letters (incl. accents), digits, spaces, ' ’ - . and at least one letter or digit. */
export const PERSON_NAME_PATTERN =
  /^(?=.*[\p{L}\p{N}])[\p{L}\p{M}\p{N} '’.-]+$/u;

/** Characters a person name box may hold (used to clean prefilled text). */
export const PERSON_NAME_DISALLOWED = /[^\p{L}\p{M}\p{N} '’.-]/gu;

export const isPersonName = (value: string): boolean =>
  PERSON_NAME_PATTERN.test(value.trim());

/** The error for one name box, or "" when fine. Empty = fine (required is checked separately). */
export const personNameProblem = (
  value?: string | null,
  max: number = NAME_PART_MAX,
  min: number = NAME_PART_MIN,
): string => {
  const text = (value || "").trim();
  if (!text) return "";
  if (!isPersonName(text)) return PERSON_NAME_RULE;
  if (text.length < min) return `Must be at least ${min} characters`;
  if (text.length > max) return `Must not be more than ${max} characters`;
  return "";
};

/** react-hook-form `validate` for an optional name box. */
export const validatePersonName =
  (max: number = NAME_PART_MAX, min: number = NAME_PART_MIN) =>
  (value?: string | null): true | string =>
    personNameProblem(value, max, min) || true;
